import {
    createEntityAdapter,
    EntityAdapter,
    EntityState
} from '@ngrx/entity';

import { IDatiqError } from '@dat/datiq-core/models';
import { IDatiqLog } from '../models';

export const DATIQ_LOG_FEATURE_KEY = 'datiqLog';

/**
 * Interface for the 'DatiqLog' data
 */
export interface IDatiqLogEntity {
    id: string; // Primary ID
    log: IDatiqLog;
    error?: {
        stack: string;
    };
}

export interface State extends EntityState<IDatiqLogEntity> {
    selectedId?: string; // which DatiqLog record has been selected
    loaded: boolean; // has the DatiqLog list been loaded
    error?: IDatiqError; // last known error (if any)
}

export interface DatiqLogPartialState {
    readonly [DATIQ_LOG_FEATURE_KEY]: State;
}

export const datiqLogAdapter: EntityAdapter<IDatiqLogEntity> =
    createEntityAdapter<IDatiqLogEntity>();

export const initialState: State = datiqLogAdapter.getInitialState({
    // set initial required properties
    loaded: false,
});
